var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-button"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"button",class:[
            { 'button--active': _vm.isOptionSelected(option) } ],on:{"click":function($event){_vm.selectOption(option)}}},[_c('div',{staticClass:"button__text"},[_vm._v(_vm._s(option.value))])])}))}
var staticRenderFns = []

export { render, staticRenderFns }